export default {
  form: {
    headers: {
      seriesVisibility: "Series exclusions",
    },
    labels: {
      newUI: "New UI",
      rpgSkillsEnabled: "RPG",
      rpgAiCollaborationEnabled: "AI Collaboration (requires RPG)",
      rpgLimit: "RPG limit",
      rpgLimitPlaceholder: "No limit",
      rpgAiBudget: "Monthly RPG AI budget ($)",
      rpgAiBudgetPlaceholder: "No limit",
      rpgAiBudgetHint: "Once the amount is reached in a month, employees cannot start a new exercise.",
      seriesHideMode: "Series exclusion mode",
      seriesHideExcludeOnly: "Exclude only selected series",
      seriesHideExcludeAllExcept: "Exclude all except selected series",
      seriesHideHiddenSeries: "Series to exclude",
      seriesHideVisibleSeries: "Series that should stay visible",
    },
  },
};
